/* VX COD + Razorpay form */
(function () {
  'use strict';

  function money(paise) {
    return 'Rs. ' + (paise / 100).toFixed(2).replace(/\.00$/, '');
  }

  function init(root) {
    var endpoint = root.getAttribute('data-endpoint');
    var rzpKey = root.getAttribute('data-rzp-key');
    var variantId = root.getAttribute('data-variant-id');
    var unitPrice = parseInt(root.getAttribute('data-price'), 10) || 0; /* paise */
    var title = root.getAttribute('data-title');
    var store = root.getAttribute('data-store');

    var qtyInput = root.querySelector('input[name="vx_qty"]');
    var totalEl = root.querySelector('[data-vx-cod-total]');
    var msgEl = root.querySelector('[data-vx-cod-msg]');

    function qty() { return Math.max(1, Math.min(10, parseInt(qtyInput.value, 10) || 1)); }
    function total() { return unitPrice * qty(); }
    function renderTotal() { if (totalEl) totalEl.textContent = money(total()); }
    renderTotal();

    root.querySelectorAll('[data-vx-cod-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        qtyInput.value = Math.max(1, Math.min(10, qty() + parseInt(btn.getAttribute('data-vx-cod-qty'), 10)));
        renderTotal();
      });
    });
    qtyInput.addEventListener('change', renderTotal);

    function showMsg(text, ok) {
      msgEl.hidden = false;
      msgEl.textContent = text;
      msgEl.className = 'vx-cod__msg ' + (ok ? 'is-ok' : 'is-err');
      msgEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function getForm() {
      var f = {
        name: root.querySelector('input[name="vx_name"]').value.trim(),
        phone: root.querySelector('input[name="vx_phone"]').value.replace(/\D/g, ''),
        address: root.querySelector('input[name="vx_address"]').value.trim(),
        city: root.querySelector('input[name="vx_city"]').value.trim(),
        pincode: root.querySelector('input[name="vx_pincode"]').value.replace(/\D/g, '')
      };
      if (f.name.length < 2) return showMsg('Please enter your full name.', false), null;
      if (f.phone.length !== 10) return showMsg('Please enter a valid 10 digit mobile number.', false), null;
      if (f.address.length < 8) return showMsg('Please enter your full address.', false), null;
      if (f.city.length < 2) return showMsg('Please enter your city.', false), null;
      if (f.pincode.length !== 6) return showMsg('Please enter a valid 6 digit pincode.', false), null;
      return f;
    }

    function setBusy(b) {
      root.querySelectorAll('[data-vx-pay]').forEach(function (x) {
        x.disabled = b;
        x.classList.toggle('is-busy', b);
      });
    }

    function submitOrder(payload, btnLabel) {
      setBusy(true);
      showMsg('Placing your order, please wait...', true);
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.text(); })
        .then(function (t) {
          var d;
          try { d = JSON.parse(t); } catch (e) { d = { ok: false }; }
          if (d.ok) {
            root.querySelector('.vx-cod__grid').hidden = true;
            root.querySelector('.vx-cod__qtyrow').hidden = true;
            root.querySelector('.vx-cod__actions').hidden = true;
            showMsg('Order confirmed! Order number: ' + (d.order || '') + '. We will ship it within 24 hours. Thank you!', true);
          } else {
            showMsg(d.error || 'Something went wrong. Please try again or use the Buy It Now button above.', false);
          }
        })
        .catch(function () {
          showMsg('Network problem. Please try again or use the Buy It Now button above.', false);
        })
        .finally(function () { setBusy(false); });
    }

    root.querySelectorAll('[data-vx-pay]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = getForm();
        if (!f) return;
        var mode = btn.getAttribute('data-vx-pay');

        if (mode === 'cod') {
          submitOrder({
            mode: 'cod',
            customer: f,
            variant_id: variantId,
            qty: qty(),
            client_total: total()
          });
          return;
        }

        /* prepaid via Razorpay */
        if (!window.Razorpay) { showMsg('Payment loading, please try again in 2 seconds.', false); return; }
        var rzp = new window.Razorpay({
          key: rzpKey,
          amount: total(),
          currency: 'INR',
          name: store,
          description: title + ' x ' + qty(),
          prefill: { name: f.name, contact: f.phone },
          notes: { address: f.address + ', ' + f.city + ' - ' + f.pincode },
          theme: { color: '#FF4629' },
          handler: function (resp) {
            submitOrder({
              mode: 'prepaid',
              customer: f,
              variant_id: variantId,
              qty: qty(),
              client_total: total(),
              razorpay_payment_id: resp.razorpay_payment_id
            });
          }
        });
        rzp.on('payment.failed', function () {
          showMsg('Payment failed or cancelled. You can try again or choose Cash on Delivery.', false);
        });
        rzp.open();
      });
    });
  }

  function boot() { document.querySelectorAll('[data-vx-cod]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
